import { CommonModule } from '@angular/common';
import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

import { IOpener } from '../opener/opener.model';
import { PopupItemCloseDirective } from './popup-item-close.directive';
import { IPopup } from './popup.model';

@Component({
    selector: 'bg-popup',
    templateUrl: './popup.component.html',
    imports: [CommonModule, PopupItemCloseDirective],
})
export class PopupComponent implements IPopup {
    @Input() bgOpenerTriggerFor: IOpener;
    @HostBinding('class.bg-popup-active') isOpen: boolean = false;
    @Output() popupOpen = new EventEmitter<void>();
    @Output() popupClose = new EventEmitter<void>();

    constructor() {}

    open() {
        this.isOpen = true;
        this.popupOpen.emit();
    }

    close() {
        this.isOpen = false;
        this.popupClose.emit();
    }

    closeOpener() {
        this.bgOpenerTriggerFor.close();
    }
}
